export const firebaseConfig = {
  apiKey: "AIzaSyA_3riPwd6ftMOz5Gc0-ZMWT8pJ6SsnVtA",
  authDomain: "iotconnect-hsw.firebaseapp.com",
  projectId: "iotconnect-hsw",
  storageBucket: "iotconnect-hsw.appspot.com",
  messagingSenderId: "832606045243",
  appId: "1:832606045243:web:af7faf182d50254aaa481e"
};
